import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, Actions, ofType } from '@ngrx/effects';

import { ReferralsService } from '../services/referrals';
import { Observable, of } from 'rxjs';
import * as referralsActions from '../actions/referrals';
import { mergeMap, catchError } from 'rxjs/operators';
import { Referrals } from '../models/referrals';

@Injectable()
export class ReferralsEffects {
  @Effect()
  loadReferrals: Observable<Action> = this.actions$.pipe(
    ofType<referralsActions.LoadReferrals>(referralsActions.LOAD_REFERRALS),
    mergeMap((action: referralsActions.LoadReferrals) =>
      this.referralsService.getReferrals(action.payload.id).pipe(
        mergeMap((referralsResponse: Referrals) => [
          new referralsActions.ClearReferrals(),
          new referralsActions.LoadReferralsSuccess(referralsResponse),
        ]),
        catchError((error, caught) =>
          of(new referralsActions.ReferralsActionFail(error))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private referralsService: ReferralsService
  ) {}
}
